import { render, staticRenderFns } from "./form-scale.vue?vue&type=template&id=5be27271&scoped=true&"
import script from "./form-scale.vue?vue&type=script&lang=ts&"
export * from "./form-scale.vue?vue&type=script&lang=ts&"
import style0 from "./form-scale.vue?vue&type=style&index=0&id=5be27271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be27271",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
